import { useCallback, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material';
import { Icon } from '@treedis/tour-loader';
import ReelVideo from '@/components/tour/regular/bottomBar/ReelVideoBar/ReelVideo';
import { Props, Video } from './types';
import { Root, Reel, Reels, Bar } from './styles';

const ReelVideoBar = (props: Props) => {
  const { show, videos, host, onMuteClick, onFullscreenClick, onPinClick, audioOnly } = props;
  const reelRef = useRef(null);
  const { palette } = useTheme();

  const [reels, setReels] = useState<Video[]>([]);

  const scrollHorizontally = useCallback((e) => {
    if (reelRef?.current) {
      e = window.event || e;
      const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      reelRef.current.scrollLeft -= delta * 10;
      e.preventDefault();
    }
  }, []);

  useEffect(() => {
    if (videos !== reels) {
      setReels(videos);
    }
  }, [reels, videos]);

  useEffect(() => {
    const ref = reelRef?.current;
    if (ref) {
      ref.addEventListener('DOMMouseScroll', scrollHorizontally, false);
      ref.addEventListener('mousewheel', scrollHorizontally, false);
    }
    return () => {
      if (ref) {
        ref.removeEventListener('DOMMouseScroll', scrollHorizontally);
        ref.removeEventListener('mousewheel', scrollHorizontally);
      }
    };
  }, [scrollHorizontally]);

  const handleMuteClick = useCallback(
    (item: any) => () => {
      if (host) {
        onMuteClick(item.sid);
      }
    },
    [onMuteClick],
  );

  return (
    <Root show={show} ref={reelRef}>
      <Reels>
        {reels.map((item, i) => (
          <Reel key={item.sid}>
            <ReelVideo
              key={item.track?.id || item.sid}
              track={item.track}
              enabled={item.enabled}
              name={item.name}
              // eslint-disable-next-line no-nested-ternary
              avatarImage={audioOnly && item?.avatarImage}
            />

            <Bar>
              <span>{item.enabled || item.joining ? item.name : ''}</span>
              {!item.self && (
                <Icon
                  type="fas"
                  sx={{
                    color: item.muted ? palette.error.main : palette.success.main,
                  }}
                  icon={item.muted ? 'fa-microphone-slash microphone off' : 'fa-microphone microphone on'}
                  onClick={handleMuteClick(item)}
                  fontSize="11px"
                />
              )}

              {!audioOnly && (
                <i
                  className={item.fullscreen ? 'fas fa-compress' : 'fas fa-expand'}
                  onClick={() => {
                    onFullscreenClick(item);
                  }}
                />
              )}
              <i className="far fa-circle" onClick={() => onPinClick(item)} />
            </Bar>
          </Reel>
        ))}
      </Reels>
    </Root>
  );
};

export default ReelVideoBar;
